import React, {Component} from "react";
// import {BG} from '../iconsSvg'
// import mask from '../img/Mask.png'
import Autoscroll from 'autoscroll-react';
//components
import Receiver from "./Receiver"
import Sender from "./Sender"

class Body extends Component {
    render() {
        let {history, onMessage, config, fontSize, handleShowEmoji, locale, access, previewFileName, isMenuReceiver, heightMenu, handlerCarouselLength} = this.props;
        let pos = history.data && history.data.length - 1;

        return (
            <div id="smBody"
                 className={`sm-body ${fontSize} ${access || isMenuReceiver ? 'with-menu' : ''} ${heightMenu !== '' ? heightMenu : ''} ${previewFileName ? 'with-preview' : ''}`}
                 onClick={() => handleShowEmoji(false)}
                 // style={{backgroundImage: `url(${mask})`}}
            >
                {history.data && history.data.map((el, i) => el.receiver ?
                    <Receiver key={i}
                              iterator={i}
                              data={el.receiver}
                              locale={locale}
                              isShow={i === pos}
                              onMessage={onMessage}
                              config={config}
                              handlerCarouselLength={handlerCarouselLength}
                              time={el.time ? el.time : null}
                    /> :
                    <Sender key={i}
                            iterator={i}
                            data={el.sender}
                            locale={locale}
                            onMessage={onMessage}
                            time={el.time ? el.time : null}
                            configIsShowingMessage={config.isShowingMessage && config.isShowingMessage.sender === el.sender ? true : null}
                    />
                )}

                {config.eventFeedback === 'TYPING' && config.eventFeedback !== undefined && <div className="sm-typing">
                    <div className="sm-spinner">
                        <div className="bounce1"/>
                        <div className="bounce2"/>
                        <div className="bounce3"/>
                    </div>
                </div>}
                {/*{BG}*/}
            </div>
        )
    }
}

export default Autoscroll(Body);



// WEBPACK FOOTER //
// ./src/components/Body/index.js